import { BaseModal } from './baseModal'
import { createSelectors } from '../utils/selectorUtils';
import { createLogger } from '../utils/debugLogger';
const l = createLogger('ModalPrice.js');
import noUiSlider from 'nouislider';

export class ModalPrice extends BaseModal {
    static Selectors = createSelectors({
        INPUT: {
            PRICE_SLIDER: `data-ts-price-slider`,
            PRICE_SELECTED_MAX: `data-ts-price-max`,
            RANGE_MIN: `data-ts-price-range-minprice`,
            RANGE_MAX: `data-ts-price-range-maxprice`
        },
        TEXT: {
            PRICE_MAX: `data-ts-price-maxtext`
        }
    });

    static Config = {
        QUERY_STRING_KEY: 'filterpricemax'
    }



    constructor(modalName, queryStringManager = null) {
        super(modalName, queryStringManager);

        const parentLoadModalContent = this.loadModalContent.bind(this);
        const parentDispose = this.dispose.bind(this);



        this.dispose = async function () {
            await parentDispose(); //check if super.dispose() works

            l.log('Disposing price slider');
            const slider = document.querySelector(this.constructor.Selectors.INPUT.PRICE_SLIDER);
            if (slider && slider.noUiSlider) {
                slider.noUiSlider.destroy();
            }
        };

        this.loadModalContent = async (evt) => {
            l.log('ModalPrice: Pre-load processing');

            // Call parent method using stored reference
            await parentLoadModalContent.call(this, evt);

            if (!this.isLoaded) {
                l.log(`${this.modalName}: base not loaded`);
                return;
            }


            const slider = document.querySelector(this.constructor.Selectors.INPUT.PRICE_SLIDER);
            if (slider && typeof slider.noUiSlider === "undefined") {
                noUiSlider.create(slider, {
                    start: this.getSelectedMaxPrice(),
                    step: 200,
                    connect: [true, false],
                    pips: {
                        mode: 'steps',
                        density: 200,
                        format: {
                            // 'to' the formatted value. Receives a number.
                            to: function (value) {

                                return '&pound;' + value;
                            },
                            // 'from' the formatted value.
                            //Receives a string, should return a number.
                            from: function (value) {
                                return Number(value.replace('&pound;', ''));
                            }
                        }
                    },
                    range: {
                        'min': this.getRangeMinPrice(),
                        'max': this.getRangeMaxPrice()
                    }
                });

                //onSlider Change - Update textboxes
                slider.noUiSlider.on('update', (values, handle) => {
                    document.querySelector(this.constructor.Selectors.INPUT.PRICE_SELECTED_MAX).value = Math.round(values[handle]);
                    document.querySelector(this.constructor.Selectors.TEXT.PRICE_MAX).innerHTML = Math.round(values[handle]);
                });

                slider.noUiSlider.on('end', function (values, handle) {
                    //stop slider been less than 400
                    if (values[handle] < 400) {
                        slider.noUiSlider.set(400);
                    }
                });

                slider.noUiSlider.set(this.getSelectedMaxPrice());

                this.attachHandler(
                    'priceTextboxChange',
                    (e) => {
                        l.log('Add priceTextbox changed', e, this.getSelectedMaxPrice());
                        slider.noUiSlider.set(this.getSelectedMaxPrice());
                    },
                    `${this.constructor.Selectors.INPUT.PRICE_SELECTED_MAX}`,
                    ['change']
                );
            }
        };
    }

    clearSelected = () => {
        l.log(`${this.modalName}: clearSelected`);
        document.querySelector(this.constructor.Selectors.INPUT.PRICE_SELECTED_MAX).value = this.getRangeMaxPrice();
        const slider = document.querySelector(this.constructor.Selectors.INPUT.PRICE_SLIDER);
        slider.noUiSlider.set(this.getSelectedMaxPrice());
    }

    getSelectedValues() {
        return [[this.constructor.Config.QUERY_STRING_KEY, this.getSelectedMaxPrice().toString()]];
    }

    getRangeMaxPrice() {
        return parseFloat(document.querySelector(this.constructor.Selectors.INPUT.RANGE_MAX).value);
    }

    getRangeMinPrice() {
        return parseFloat(document.querySelector(this.constructor.Selectors.INPUT.RANGE_MIN).value);
    }

    getSelectedMaxPrice() {
        return parseFloat(document.querySelector(this.constructor.Selectors.INPUT.PRICE_SELECTED_MAX).value);
    }

    // Now we have to use the factory method
    static createModal(queryStringManager) {
        return BaseModal.create.call(this, 'ModalPrice', queryStringManager);
    }
}
